import { render, staticRenderFns } from "./signModel.vue?vue&type=template&id=beca2a92&scoped=true"
import script from "./signModel.vue?vue&type=script&lang=js"
export * from "./signModel.vue?vue&type=script&lang=js"
import style0 from "./signModel.vue?vue&type=style&index=0&id=beca2a92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beca2a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beca2a92')) {
      api.createRecord('beca2a92', component.options)
    } else {
      api.reload('beca2a92', component.options)
    }
    module.hot.accept("./signModel.vue?vue&type=template&id=beca2a92&scoped=true", function () {
      api.rerender('beca2a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/signModel.vue"
export default component.exports